import { render } from "./ServiceSubmitLayout.vue?vue&type=template&id=31b387cc&scoped=true"
import script from "./ServiceSubmitLayout.vue?vue&type=script&lang=js"
export * from "./ServiceSubmitLayout.vue?vue&type=script&lang=js"

import "./ServiceSubmitLayout.vue?vue&type=style&index=0&id=31b387cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b387cc"]])

export default __exports__